import { LIMIT } from '@/api/apiModules'
export default {
  viewType: 'table',
  module: LIMIT,
  sortArr: [
    {
      fieldName: 'createTime',
      direction: 'DESC'
    }
  ],
  refreshInterval: false,
  params: {},
  extraParams: {},
  allowStatus: {
    LimitEdit: { self: [true] }
  },
  toolbar: {
    searchWidth: 360,
    searchPlaceholder: '限制说明',
    searchFieldNameArr: ['limitDesc'],
    items: [
      {
        slot: 'refresh-rigtht',
        label: '添加限制说明',
        props: {
          type: 'primary',
          icon: 'el-icon-plus'
        },
        action: 'LimitCreate'
      },
      {
        slot: 'left-rigtht',
        label: '当前功能：     ',
        props: {
          type: 'text'
        }
      }
    ]
  },
  class: 'sk-custom-table-right-page',
  view: {
    'cell-class-name': 'sk-customize-cell-hight',
    columns: [
      {
        props: {
          label: '提供人',
          prop: 'createUser',
          width: 100
        }
      },
      {
        props: {
          label: '限制说明',
          prop: 'limitDesc'
        }
      },
      {
        props: {
          label: '有用',
          prop: 'likeNum',
          width: 80
        }
      },
      {
        props: {
          label: '无用',
          prop: 'dislikeNum',
          width: 80
        }
      },
      {
        props: {
          label: '提供时间',
          prop: 'createTime',
          sortField: 'createTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          label: '更新时间',
          prop: 'updateTime',
          width: 160
        },
        dataType: 'date'
      },
      {
        props: {
          showBtnNum: '2',
          fixed: null
        },
        dataType: 'operation'
      }
    ],
    menus: [
      {
        icon: 'el-icon-edit',
        label: '编辑',
        command: 'LimitEdit',
        name: 'LimitEdit',
        tip: '本人创建才能进行编辑'
      },
      {
        icon: 'el-icon-upload',
        label: '有用',
        command: 'LimitDoLike',
        name: 'LimitDoLike'
      },
      {
        icon: 'sk-icon-invisible',
        label: '无用',
        command: 'LimitDoDislike',
        name: 'LimitDoDislike'
      }
    ]
  }
}
